import React from "react";
import styled from "styled-components";
import { MdPhone, MdEmail } from "react-icons/md";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";
// Assets
import LogoImg from "../../assets/svg/LogoLight";

export default function Footer() {
  const getCurrentYear = () => new Date().getFullYear();
  
  return (
    <Wrapper>
      <div className="greenBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            <FooterSection>
              <a className="flexCenter animate pointer" href="/" smooth={true} offset={-80}>
                <LogoImg />
              </a>
            </FooterSection>
            
            <FooterSection>
              <SectionTitle>Quick Links</SectionTitle>
              <LinkList>
                <LinkItem><StyledLink href="/home">Home</StyledLink></LinkItem>
                <LinkItem><StyledLink href="/programs">Our Programs</StyledLink></LinkItem>
                <LinkItem><StyledLink href="/opportunities">Opportunities</StyledLink></LinkItem>
              </LinkList>
            </FooterSection>
            
            <FooterSection>
              <SectionTitle>Resources</SectionTitle>
              <LinkList>
                <LinkItem><StyledLink href="/register">Register</StyledLink></LinkItem>
                <LinkItem><StyledLink href="/request-demo">Request Demo</StyledLink></LinkItem>
                <LinkItem><StyledLink href="/home#testimonials">Success Stories</StyledLink></LinkItem>
              </LinkList>
            </FooterSection>
            
            <FooterSection>
              <SectionTitle>Contact Us</SectionTitle>
              <ContactWrapper>
                <ContactItem>
                  <MdPhone className="icon" />
                  <span>+250 789 942 582</span>
                </ContactItem>
                <ContactItem>
                  <MdEmail className="icon" />
                  <span>info@ideachallenge.net</span>
                </ContactItem>
              </ContactWrapper>
              
              <SocialWrapper>
                <SocialIcon href="https://www.linkedin.com/company/idea-rwanda" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn />
                </SocialIcon>
                <SocialIcon href="https://www.instagram.com/idea.challengerw" target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </SocialIcon>
              </SocialWrapper>
            </FooterSection>
          </InnerWrapper>
          
          <Copyright className="whiteColor font13">
            © {getCurrentYear()} - <span className="yellowColor font13">Idea Challenge</span> All Rights Reserved
          </Copyright>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.footer`
  width: 100%;
  flex-shrink: 0; /* Prevents the footer from shrinking */
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const FooterSection = styled.div`
  flex: 1;
  min-width: 200px;
  margin-right: 20px;
  
  @media (max-width: 992px) {
    margin-right: 0;
    text-align: center;
  }
`;

const SectionTitle = styled.h4`
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -8px;
    width: 40px;
    height: 2px;
    background-color: #eea746;
    
    @media (max-width: 992px) {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
`;

const LinkItem = styled.li`
  margin-bottom: 8px;
`;

const StyledLink = styled.a`
  color: #fff;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #eea746;
    text-decoration: none;
  }
  
  &:before {
    content: "›";
    margin-right: 8px;
    color: #eea746;
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  
  .icon {
    color: #eea746;
    margin-right: 8px;
    font-size: 18px;
  }
  
  @media (max-width: 992px) {
    align-items: center;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
`;

const SocialWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 15px;
  
  @media (max-width: 992px) {
    justify-content: center;
  }
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #eea746;
    transform: translateY(-3px);
    color: #fff;
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 30px;
`;